import React, { useMemo } from 'react';
import { ComposableDevicesManagerStoreInfoResponse } from '../../../../../service/device/hooks/useDevicesManager';
import { ComposableDevicesStoreInfoResponse } from '../../../../../service/store/hooks/useDevicesWithComposableDevice';
import { useMetrics } from '../../ManagerPerformances/hooks/useMetrics';
import { toBase64 } from '../../../../../shared/util/base64';
import { GetWifiSignalIcon } from '../../../../../shared/util/rssi/getIcon';
import { Box, CircularProgress } from '@mui/material';

interface RSSIOverviewByDeviceProps {
  device:
    | ComposableDevicesStoreInfoResponse
    | ComposableDevicesManagerStoreInfoResponse;
}
export const RSSIOverviewByDevice = (props: RSSIOverviewByDeviceProps) => {
  const { device } = props;

  const deviceId = device?.uuid;
  const commanderId = device?.commanderId;

  const defaultAnalogFilter = useMemo(() => {
    const controlUnits =
      device.composableDevice?.controlUnits.map(
        (controlUnit) => controlUnit.controlUnitId
      ) ?? [];

    return {
      [toBase64(device.uuid)]: controlUnits.reduce(
        (acc, controlUnitId) => ({
          ...acc,
          [controlUnitId]: { RSSI: true },
        }),
        {}
      ),
    };
  }, [device.uuid, device.composableDevice?.controlUnits]);
  /** Init Monitoring */
  const { loading, metrics } = useMetrics({
    deviceId,
    commanderId,
    groupId: device.storeId ?? '',
    defaultAnalogFilter,
    defaultDigitalFilter: {},
  });
  const { sensordata } = metrics;
  const lastData = useMemo(() => {
    const info = sensordata?.[sensordata.length - 1]?.data;
    return info ? info[0] : null;
  }, [sensordata]);
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      {loading ? (
        <CircularProgress style={{ height: '1.5rem', width: '1.5rem' }} />
      ) : (
        <GetWifiSignalIcon rssi={Number(lastData?.val)} width={'2rem'} />
      )}
    </Box>
  );
};
